import { put, cancelled } from 'redux-saga/effects';

import { noop, uniq } from 'lodash';

import config from 'config';
import { authApi } from 'config/antonio';
import * as log from 'config/loglevel';

import { takeRequest } from 'services/sagas/takeRequest';

import { createUIErrorMessage } from 'modules/errors';
import { geocodeCoordinates } from 'modules/entities/modules/elevator-coordinates';

import { Elevator } from '../../types';
import { fetchMaintenancesTypes, fetchMaintenances as actions } from '../actions';
import { getPropertyUnitAdress } from '../utils';

function* fetchMaintenances() {
    // eslint-disable-next-line compat/compat
    const controller = new AbortController();

    try {
        const { data } = yield* authApi.get<Elevator[]>(config.api.maintenances, {
            signal: controller.signal,
        });
        yield put(actions.fetchMaintenancesSuccess(data));

        const addresses = uniq(data.map(elevator => getPropertyUnitAdress(elevator.propertyUnit)));

        yield put(geocodeCoordinates(addresses));
    } catch (error) {
        log.error(error);
        const uiError = createUIErrorMessage(error);
        yield put(actions.fetchMaintenancesFailure(uiError));
    } finally {
        if (yield cancelled()) {
            controller.abort();
        }
    }
}

export default function* () {
    yield takeRequest(
        {
            requestIdSelector: () => 'fetchMaintenancesRequest',
            leading: true,
        },
        {
            pattern: fetchMaintenancesTypes.FETCH_MAINTENANCES_REQUEST,
            handler: fetchMaintenances,
        },
        {
            pattern: fetchMaintenancesTypes.FETCH_MAINTENANCES_CANCEL,
            handler: noop,
        },
    );
}
